import { render, staticRenderFns } from "./FantasyItemCard.vue?vue&type=template&id=5e48b4be&scoped=true&"
import script from "./FantasyItemCard.vue?vue&type=script&lang=js&"
export * from "./FantasyItemCard.vue?vue&type=script&lang=js&"
import style0 from "./FantasyItemCard.vue?vue&type=style&index=0&id=5e48b4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48b4be",
  null
  
)

export default component.exports